import React from 'react';
import Box from 'sail/Box';
import {BodyMono} from 'sail/Text';
import Grid, {GridItem} from 'sail/Grid';

export const dimensions = {width: 390, height: 36};

// Contains column header for an input grid
export const HeaderBox = (props) => {
  const values = {
    style: {width: dimensions.width},
  };

  return <Box {...values}>{props.children}</Box>;
};

// Contains series of input rows, adds border
export const GridBox = (props) => {
  const values = {
    style: {width: dimensions.width * 2},
    divider: {side: 'all'},
  };

  return (
    <Box {...values}>
      <Grid gap={0}>{props.children}</Grid>
    </Box>
  );
};

// Contains label for an input row
export const LabelBox = (props) => {
  const values = {
    style: {...dimensions},
    divider: {side: 'bottom'},
    padding: {vertical: 8, horizontal: 16},
  };

  return (
    <Box {...values}>
      <BodyMono color={props.required ? 'default' : 'gray'}>
        {props.children}
      </BodyMono>
    </Box>
  );
};

// Represents an input row with a label and input component
export const GridRow = (props) => {
  return (
    <>
      <GridItem columnSpan={6} row={props.row}>
        <LabelBox required={props.required}>{props.label}</LabelBox>
      </GridItem>
      <GridItem column={7} columnSpan={6} row={props.row}>
        {props.children}
      </GridItem>
    </>
  );
};
